'use client';

import { Link } from 'react-router-dom';
import styles from '../ProductDetail.module.css';

export function AkustikDuzSungerHubContent() {
  return (
    <div className={styles.seoWrap}>
      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Düz Sünger Nedir?</h2>
        <p className={styles.seoText}>
          Akustik düz sünger, yüzeyinde profil işlemi bulunmayan açık hücreli ses emici bir malzemedir.
          Kapalı alanlarda oluşan yankıyı, çınlamayı ve ses yansımalarını azaltmak için kullanılır.
          Poliüretan esaslı üretilir. Düz yüzey yapısı geniş alan kaplamalarında ekonomik ve pratik bir
          çözüm sunar.
        </p>
        <p className={styles.seoText}>
          BariyerliBondexSunger.com olarak Echopan markasıyla sunduğumuz düz akustik sünger modelleri
          stüdyo, ofis, eğitim kurumu ve endüstriyel projelerde yaygın olarak tercih edilir. Ürün oda
          içi akustik düzenleme sağlar. Komşu odadan gelen sesi engellemez. Ses geçişi için{' '}
          <Link to="/bondex-sunger" rel="follow">
            Bondex sünger
          </Link>{' '}
          gibi yalıtım malzemeleri ayrıca değerlendirilmelidir.
        </p>
        <p className={styles.seoText}>
          Düz sünger duvar ve tavana uygulanır. Siyah, koyu gri ve antrasit tonlarda üretilir. Yangına
          dayanıklı E sınıfı sertifikaya sahiptir. Stoklarımızda 20 ile 50 mm arası kalınlık seçenekleri
          mevcuttur. Standart plaka ölçüsü 100x100 cm dir. Fiyat metrekare başına 320 TL dir.
        </p>
        <p className={styles.seoText}>
          Akustik düz sünger ses yalıtım malzemesi değildir. Duvar arkasına yerleştirilerek komşu sesi
          kesilmez. Oda içi yüzeye yapıştırıldığında yankı azalır. Bu ayrım doğru ürün seçiminin
          temelidir.
        </p>
        <p className={styles.seoText}>
          Düz akustik sünger paneli fabrikadan kesilmiş plaka halinde gelir. Profil işlemi olmadığı için
          üretim süresi kısadır. Stoktan hızlı sevkiyat yapılabilir. Acil proje taleplerinde aynı gün
          kargo mümkündür. Sipariş öncesi metraj paylaşıldığında panel adedi hesaplanır.
        </p>

        <h3 className={styles.seoSubtitle}>Düz yüzeyli akustik süngerin özellikleri</h3>
        <p className={styles.seoText}>
          Düz yüzeyli akustik sünger açık hücreli gözenek yapısına sahiptir. Yoğunluk genelde 25 ile
          35 kg/m³ aralığındadır. NRC değeri 0.75 ve üzeridir. Profil işlemi olmadığı için üretim maliyeti
          düşüktür. Malzeme hafiftir, kolay kesilir ve monte edilir.
        </p>
        <p className={styles.seoText}>
          Echopan üretim hattında her parti kalınlık ve yoğunluk açısından kontrol edilir. Kesim kenarları
          düzgündür. Kendinden yapışkanlı versiyon sipariş edilebilir. TS EN 13501-1 standardına göre E
          sınıfı yanmazlık belgesi mevcuttur. Ticari projelerde sertifika talep edildiğinde paylaşılır.
        </p>
        <p className={styles.seoText}>
          Düz profil geniş yüzey kaplamalarında en çok tercih edilen formdur. Toz tutmaz yapıdadır. Uzun
          vadede performans kaybı yaşanmaz. Maket bıçağı ile özel şekil ve köşe detayları hızlıca
          hazırlanır. Ahşap veya metal karkas üzerine monte edilebilir.
        </p>
        <p className={styles.seoText}>
          Düz yüzey boyama veya kumaş kaplama için uygun bir alt tabaka oluşturur. Akustik kumaş panel
          arkasına yerleştirildiğinde görünür yüzey değişir ancak emilim performansı korunur. Siyah ve
          koyu gri renkler ışık yansımasını minimuma indirir.
        </p>

        <h3 className={styles.seoSubtitle}>Akustik düz sünger hangi amaçla kullanılır?</h3>
        <p className={styles.seoText}>
          Akustik düz sünger oda içi yankı kontrolü için kullanılır. Reverberasyon süresini kısaltır.
          Konuşma netliğini artırır. Kayıt kalitesini iyileştirir. Geniş alanlarda ekonomik kaplama
          sağlar. Sade görünüm isteyen projelerde tercih edilir.
        </p>
        <p className={styles.seoText}>
          Düz sünger ses geçişini engellemez. Duvar arkasına serilerek komşu sesi kesilmez. Oda içi
          yüzeye yapıştırıldığında yansımalar emilir. Stüdyo, ofis ve endüstriyel alanlarda aynı
          prensiple çalışır. Doğru beklenti ile kullanıldığında etkili sonuç verir.
        </p>
        <p className={styles.seoText}>
          Bass trap ve köşe uygulamalarında kalın düz panel kullanılır. Duvar ve tavan kaplamasında ince
          ve orta kalınlık tercih edilir.           Teknik ekibimiz kullanım amacına göre kalınlık önerir.
        </p>
        <p className={styles.seoText}>
          RT60 değeri oda akustiğinin temel ölçütlerinden biridir. Düz panel uygulaması bu değeri
          kısaltır. Konuşma frekanslarında belirgin iyileşme sağlanır. Müzik kaydında oda tonu kontrol
          altına alınır. Doğru kaplama oranı ile boğuk ses riski minimize edilir.
        </p>

        <h3 className={styles.seoSubtitle}>Diğer akustik sünger modellerinden farkı</h3>
        <p className={styles.seoText}>
          Genel{' '}
          <Link to="/akustik-sunger" rel="follow">
            akustik sünger
          </Link>{' '}
          kategorisinde piramit, yumurta, labirent ve düz profiller bulunur. Düz sünger profil işlemi
          olmadığı için ekonomik kaplama sağlar.{' '}
          <Link to="/akustik-piramit-sunger" rel="follow">
            Akustik piramit sünger
          </Link>{' '}
          daha keskin geometrik görünüm sunar.{' '}
          <Link to="/akustik-yumurta-sunger" rel="follow">
            Akustik yumurta sünger
          </Link>{' '}
          stüdyo ve podcast odalarında estetik tercih edilir.{' '}
          <Link to="/akustik-labirent-sunger" rel="follow">
            Labirent akustik sünger
          </Link>{' '}
          geniş tavan uygulamalarında kullanılır.
        </p>
        <p className={styles.seoText}>
          Profilli süngerler aynı kalınlıkta düz modele göre daha geniş frekans bandında çalışabilir.
          Düz sünger orta ve yüksek frekanslarda güçlü performans verir. Geniş alan kaplamalarında maliyet
          avantajı sağlar. Görsel olarak sade ve modern bir görünüm oluşturur.
        </p>
        <p className={styles.seoText}>
          Bondex sünger ve düz akustik sünger farklı amaçlara hizmet eder. Bondex duvar karkası içinde ses
          geçişini azaltır. Düz sünger oda içi yüzeyde yankıyı kontrol eder. Aynı projede ikisi birlikte
          kullanılabilir.
        </p>
        <p className={styles.seoText}>
          Stüdyo projelerinde arka duvara düz panel, ön duvara profilli panel kombinasyonu uygulanabilir.
          Her profil farklı frekans karakteristiği sunar. Tek profil ile tüm yüzeyi kaplamak zorunlu
          değildir.           Teknik ekibimiz profil kombinasyonu önerir.
        </p>
        <p className={styles.seoText}>
          Yanlış ürün seçimi en sık akustik süngeri duvar arkasına koyarak komşu sesini kesmeye çalışmaktır.
          Bu uygulama beklenen sonucu vermez. Düz sünger oda içi yüzeyde yankıyı azaltır. Komşu sesi için
          bondex veya bariyerli bondex değerlendirilmelidir.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Düz Sünger Nerelerde Kullanılır?</h2>
        <p className={styles.seoText}>
          Düz akustik sünger yankı kontrolü gereken her kapalı alanda kullanılabilir. Geniş metrajlı
          projelerde ekonomik tercih olur. Mekanın boyutu ve kullanım amacı kaplama planını belirler.
        </p>

        <h3 className={styles.seoSubtitle}>Ses kayıt stüdyoları</h3>
        <p className={styles.seoText}>
          Ses kayıt stüdyolarında düz sünger arka duvar ve tavan kaplamasında kullanılır. Mikrofon oda
          içindeki her yansımayı yakalar. Düz panel reverberasyon süresini kısaltır. Kontrol odasında
          dengeli akustik ortam şarttır.
        </p>
        <p className={styles.seoText}>
          Stüdyo projelerinde tüm yüzeyi kaplamak her zaman doğru değildir. Arka duvar ve ilk yansıma
          noktaları önceliklidir. Echopan teknik ekibi stüdyo metrajınıza göre kaplama oranı hesaplar.
          Mirror point hesabı ile yerleşim planı oluşturulur.
        </p>
        <p className={styles.seoText}>
          Vokal kayıt odasında arka duvar tamamen düz panel ile kaplanabilir. Enstrüman kaydında daha az
          kaplama tercih edilir.           Bass trap köşelerinde kalın düz panel kullanılır.
        </p>
        <p className={styles.seoText}>
          Kontrol odasında hoparlör sesi doğrudan kulağa ulaşmalıdır. Düz panel arka duvarda yansımayı
          emer. Ön duvar genelde açık bırakılır veya az kaplanır. Bu denge miks kararlarının doğruluğunu
          artırır. Kayıt odasında ise daha yoğun kaplama tercih edilir.
        </p>

        <h3 className={styles.seoSubtitle}>Podcast ve yayın odaları</h3>
        <p className={styles.seoText}>
          Podcast ve radyo yayın odalarında küçük hacimde bile yankı kayıt kalitesini düşürür.
          Konuşmacının arkasına düz sünger yerleştirmek çoğu durumda yeterlidir. Küçük odalarda yüzde
          25-35 kaplama oranı önerilir.
        </p>
        <p className={styles.seoText}>
          Kendinden yapışkanlı modeller ev stüdyolarında hızlı kurulum sağlar. Düz yüzey sade görünüm
          sunar. Ev ofisinde masa arkasına bir panel yeterli olabilir. Mikrofonun yakaladığı oda tonu
          kayıt kalitesini doğrudan etkiler.
        </p>
        <p className={styles.seoText}>
          Yayın stüdyolarında tavan yüksekliği düşükse tavan paneli de eklenmelidir. Halı ve perde
          yansımayı azaltır ancak sünger kadar etkili değildir. İkisini birlikte kullanmak en iyi sonucu
          verir.
        </p>
        <p className={styles.seoText}>
          YouTube ve içerik üreticileri düz profili sade görünüm için tercih eder. Kamera önünde profilli
          süngerler dikkat çekerken düz panel arka planda kalır. Ev stüdyosunda bütçe sınırlıysa önce arka
          duvar kaplanır. Sonra yan duvarlara genişletilebilir.
        </p>

        <h3 className={styles.seoSubtitle}>Ev sinema sistemleri</h3>
        <p className={styles.seoText}>
          Ev sinema odasında hoparlör sesi duvar ve tavandan yansır. Düz sünger yan ve arka duvar
          uygulamasıyla surround kanalların netliği artar. Koyu renkli paneller ışık yansımasını azaltır.
          Film deneyimi belirgin şekilde iyileşir.
        </p>
        <p className={styles.seoText}>
          Subwoofer köşelerinde bas birikimi oluşur. Köşeye kalın bass trap eklemek gerekir. Düz duvar paneli
          ve köşe bass trap birlikte kullanılır. Sade görünüm isteyen sinema odalarında düz profil ilk
          tercihtir.
        </p>
        <p className={styles.seoText}>
          Ön hoparlörlerin ilk yansıma noktası yan duvarlardadır. Bu noktalara düz panel yerleştirmek
          surround deneyimini güçlendirir. Oturma pozisyonu belirlendikten sonra panel yerleşimi planlanır.
        </p>

        <h3 className={styles.seoSubtitle}>Ofis ve çalışma alanları</h3>
        <p className={styles.seoText}>
          Ev ofisi ve küçük çalışma odalarında düz sünger yankıyı azaltır. Video konferans yapılan
          alanlarda karşı taraf temiz ses alır. Açık ofiste tavan panelleri daha yaygındır ancak kişisel
          çalışma kabinlerinde duvar uygulaması tercih edilir.
        </p>
        <p className={styles.seoText}>
          Çağrı merkezi ve küçük toplantı odalarında konuşma netliği artar. Yangın sertifikalı ürünler
          kurumsal projelerde tercih edilir. Düz profil ofis ortamında sade ve profesyonel görünüm sunar.
        </p>
        <p className={styles.seoText}>
          Küçük toplantı odalarında düz panel konuşma gizliliğini artırır. Cam bölmeli odalarda ses cam
          yüzeyden yansır. Duvar uygulaması yankıyı kontrol altına alır. Kurumsal projelerde yangın
          sertifikası zorunlu tutulur.
        </p>
        <p className={styles.seoText}>
          Hibrit çalışma modelinde ev ofisleri yaygınlaştı. Düz panel ev ofisinde video konferans kalitesini
          artırır. Açık planlı evlerde yankı sorunu belirgindir. Oturma odasında TV izlerken bile konuşma
          yankılanır. Bir duvar kaplaması bu sorunu büyük ölçüde çözer.
        </p>

        <h3 className={styles.seoSubtitle}>Eğitim kurumları</h3>
        <p className={styles.seoText}>
          Okul, üniversite ve kurs merkezlerinde düz akustik sünger müzik odası, drama stüdyosu ve
          çok amaçlı salonlarda kullanılır. Geniş sınıflarda yankı öğrenme kalitesini düşürür. Tavan ve
          arka duvar kaplaması konuşmayı netleştirir.
        </p>
        <p className={styles.seoText}>
          Eğitim kurumlarında yangın sertifikası zorunludur. E sınıfı düz sünger modellerimiz bu
          gereksinimi karşılar. Sertifika talep edildiğinde paylaşılır. Geniş metrajlı okul projelerinde
          düz panel ekonomik çözüm sunar.
        </p>
        <p className={styles.seoText}>
          Müzik odalarında enstrüman sesi yankılanır. Düz panel duvar ve tavanda uygulanarak oda tonu
          kontrol altına alınır. Drama ve tiyatro stüdyolarında sahne arkası kaplama da yapılabilir.
        </p>
        <p className={styles.seoText}>
          Dil sınıflarında telaffuz netliği önemlidir. Yankılı sınıfta öğrenci öğretmeni zor anlar. Tavan
          paneli özellikle yüksek tavanlı sınıflarda etkilidir. Okul projelerinde yaz tatili montaj planı
          yapılabilir. Büyük metraj siparişlerinde parti parti teslimat mümkündür.
        </p>

        <h3 className={styles.seoSubtitle}>Endüstriyel uygulama alanları</h3>
        <p className={styles.seoText}>
          Fabrika, atölye ve üretim alanlarında makine gürültüsü yankılanır. Düz akustik sünger tavan ve
          duvar kaplamasında gürültü seviyesini düşürür. İş güvenliği açısından çalışan konforunu artırır.
          Ses emilimi ile gürültü kontrolü sağlanır.
        </p>
        <p className={styles.seoText}>
          Endüstriyel alanlarda geniş metraj kaplama yapılır. Düz sünger birim maliyet avantajı sunar.
          Yangına dayanıklı E sınıfı modeller tercih edilir. Toz tutmaz yapı bakımı kolaylaştırır.
        </p>
        <p className={styles.seoText}>
          Makine dairesi ve jeneratör odalarında yankı kontrolü çalışma koşullarını iyileştirir. Düz
          panel hızlı monte edilir. Büyük plakalar geniş alanları kısa sürede kaplar.
        </p>
        <p className={styles.seoText}>
          CNC atölyelerinde makine sesi metal yüzeylerden yansır. Düz panel tavan kaplaması gürültü
          seviyesini düşürür. İş güvenliği mevzuatı yüksek gürültü ortamlarında önlem alınmasını gerektirir.
          Akustik kaplama bu önlemlerden biridir.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Düz Süngerin Avantajları Nelerdir?</h2>

        <h3 className={styles.seoSubtitle}>Dengeli akustik düzenleme sağlaması</h3>
        <p className={styles.seoText}>
          Düz yüzeyli panel reverberasyon süresini kısaltır. Boş odada konuşma veya müzik yansıyarak
          çınlama yapar. Sünger paneller bu yansımaları emdiğinde ortam daha kontrollü ses verir. RT60
          değeri kısaldığında gürültü algısı düşer.
        </p>
        <p className={styles.seoText}>
          Stüdyo kayıtlarında yankısız ortam elde etmek bu avantajla mümkün olur. Podcast kayıtlarında
          oda tonu düşer. Toplantı odasında konuşma netliği artar.
        </p>

        <h3 className={styles.seoSubtitle}>Sade ve modern görünüm sunması</h3>
        <p className={styles.seoText}>
          Düz profil sade ve modern bir görünüm oluşturur. Profilli süngerlere kıyasla daha minimal
          durur. Ofis, eğitim kurumu ve endüstriyel alanlarda dekorasyonla uyumlu çalışır. Koyu tonlar
          çoğu iç mekânla uyumludur.
        </p>
        <p className={styles.seoText}>
          Ev sinema odasında düz panel göze batmayan bir kaplama sağlar. Kurumsal ortamlarda profesyonel
          görünüm sunar. Estetik kaygısı düşük, fonksiyon odaklı projelerde ilk tercihtir.
        </p>

        <h3 className={styles.seoSubtitle}>Farklı kaplama sistemlerine uygun olması</h3>
        <p className={styles.seoText}>
          Düz sünger doğrudan duvara yapıştırılabilir. Ahşap karkas üzerine monte edilebilir. Akustik
          kumaş panel arkasına yerleştirilebilir. Tavan askı sistemine takılabilir. Farklı montaj
          yöntemlerine uyum sağlar.
        </p>
        <p className={styles.seoText}>
          Kendinden yapışkanlı versiyon hızlı uygulama sağlar. Mekanik sabitleme ile tavan montajı
          güçlendirilir. Büyük projelerde farklı montaj yöntemleri bir arada kullanılabilir.
        </p>

        <h3 className={styles.seoSubtitle}>Kolay uygulanabilir yapısı</h3>
        <p className={styles.seoText}>
          Düz akustik sünger hafiftir. Tek kişi paneli kaldırıp duvara yapıştırabilir. Maket bıçağı ile
          kolay kesilir. Düz yüzey kesim ve birleştirmeyi basitleştirir. Özel şekil ve köşe detayları
          hızlıca hazırlanır.
        </p>
        <p className={styles.seoText}>
          Yangına dayanıklıdır ve toz tutmaz yapıdadır. Uzun vadede bakım maliyeti düşüktür. Düzgün
          montajda panel düşmesi yaşanmaz. Ev kullanıcısı bir öğleden sonra küçük bir odayı
          düzenleyebilir.
        </p>
        <p className={styles.seoText}>
          Düz sünger nem ve rutubete karşı dayanıklıdır. Bodrum katı müzik odasında uygun yapıştırıcı
          ile sorunsuz çalışır. Uzun vadede bakım gerektirmez.           Periyodik toz alma performansı korur.
        </p>
        <p className={styles.seoText}>
          Düz yüzey profilli modele göre toz tutma riski biraz daha yüksektir. Düzenli temizlik ile bu
          sorun ortadan kalkar. Endüstriyel alanlarda periyodik bakım planı yapılmalıdır. Konut
          uygulamalarında yılda bir kez toz alma yeterlidir.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Düz Sünger Ölçüleri</h2>

        <h3 className={styles.seoSubtitle}>Standart ebat seçenekleri</h3>
        <p className={styles.seoText}>
          Standart plaka ölçüsü 100x100 cm dir. Bu ebat kargo ve montaj açısından pratiktir. 50x50 cm
          yarım plaka küçük alanlar için kullanılır. Sipariş öncesi duvar veya tavan metrajı
          hesaplanmalıdır. Teknik ekibimiz çizim üzerinden panel adedi hesaplar.
        </p>
        <p className={styles.seoText}>
          100x100 cm plaka 1 metrekare alan kaplar. Duvar yüksekliği 2.50 m ise dikeyde 2.5 panel gerekir.
          Pencere ve kapı boşlukları hesaptan düşülür. Fazla panel stokta kalır, eksik panel montajı
          geciktirir.
        </p>

        <h3 className={styles.seoSubtitle}>Kalınlık alternatifleri</h3>
        <p className={styles.seoText}>
          20 mm hafif yankı kontrolü için uygundur. 30 mm ev ve ofis projelerinde en çok satılan
          kalınlıktır. 40 mm stüdyo ve sinema odalarında tercih edilir. 50 mm yüksek performans ve bass
          trap uygulamalarında kullanılır.
        </p>
        <p className={styles.seoText}>
          Küçük odada 50 mm paneller boğuk ses üretebilir. 15 m² altı odalarda 20-30 mm yeterli olabilir.
          40 m² ve üzeri odalarda 40-50 mm daha dengeli çalışır.           Endüstriyel alanlarda 40-50 mm yaygındır.
        </p>
        <p className={styles.seoText}>
          Kalınlık seçiminde tavan yüksekliği de etkilidir. 3 m üzeri tavanlarda 40 mm panel tavan
          yansımalarını daha iyi kontrol eder. Düşük tavanlı odalarda 20-30 mm yeterli olabilir. Bass trap
          için köşelere 50 mm kalın panel yerleştirilir.
        </p>

        <h3 className={styles.seoSubtitle}>Projeye özel üretim seçenekleri</h3>
        <p className={styles.seoText}>
          Standart ölçü dışında proje bazlı kesim yapıyoruz. Eğri duvar ve tavan kasası gibi özel detaylar
          için CNC kesim hizmeti sunulur. Teknik çizim paylaşıldığında kesim listesi aynı gün hazırlanır.
          Büyük stüdyo projelerinde farklı duvarlara farklı kalınlık uygulanabilir.
        </p>
        <p className={styles.seoText}>
          Özel üretim taleplerinde proje çizimleri paylaşılmalıdır. Numune gönderimi büyük siparişlerde
          talep edilebilir. Onay sonrası toplu üretim başlar. Büyük projelerde parti parti teslimat
          planlanabilir.
        </p>
        <p className={styles.seoText}>
          Eğri tavan ve kubbe formlu mekanlarda düz panel parçalara bölünerek uygulanır. CNC kesim ile
          eğri yüzeye uyum sağlanır. Sinema salonu ve tiyatro projelerinde özel kesim sık talep edilir.
          Teknik çizim paylaşıldığında kesim planı hazırlanır.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Düz Sünger Seçerken Nelere Dikkat Edilmelidir?</h2>

        <h3 className={styles.seoSubtitle}>Kullanım alanının belirlenmesi</h3>
        <p className={styles.seoText}>
          Stüdyo, ofis, eğitim kurumu ve endüstriyel alan farklı kaplama planı gerektirir. Kullanım amacı
          belirlenmeden sipariş verilmemelidir. Podcast odası ile fabrika salonu aynı çözümü gerektirmez.
          Teknik ekibimiz kullanım alanına göre öneri sunar.
        </p>
        <p className={styles.seoText}>
          Ses kayıt odası ile toplantı odası farklı kaplama oranı gerektirir. Endüstriyel alanda geniş
          metraj kaplama yapılır. Ev kullanımında bir duvar yeterli olabilir.
        </p>

        <h3 className={styles.seoSubtitle}>Kalınlık seçimi</h3>
        <p className={styles.seoText}>
          Podcast odası ile müzik stüdyosu aynı kalınlığı gerektirmez. Küçük odada ince panel yeterli
          olabilir. Stüdyo kayıt odasında 40-50 mm tercih edilir. Yanlış kalınlık ya yetersiz performans
          ya da boğuk ses üretir.
        </p>
        <p className={styles.seoText}>
          Ev ofisinde 20 mm panel masa arkasına yerleştirildiğinde video konferans kalitesi artar. Müzik
          stüdyosunda kontrol odası ile kayıt odası farklı kalınlık gerektirebilir. Teknik ekibimiz oda
          ölçülerinizi paylaştığınızda kalınlık önerisi sunar.
        </p>

        <h3 className={styles.seoSubtitle}>Sünger yoğunluğu</h3>
        <p className={styles.seoText}>
          Yoğunluk kg/m³ cinsinden ifade edilir. Yüksek yoğunluklu sünger daha dayanıklıdır ve düşük
          frekanslarda daha iyi çalışır. Profesyonel projelerde 25-35 kg/m³ aralığı yaygındır. Bass trap
          uygulamalarında daha yüksek yoğunluk gerekir.
        </p>
        <p className={styles.seoText}>
          Endüstriyel alanlarda yüksek yoğunluk tercih edilir. Konut uygulamalarında standart yoğunluk
          yeterli olabilir.           Yoğunluk seçimi kullanım ömrünü de etkiler.
        </p>
        <p className={styles.seoText}>
          Düşük yoğunluklu sünger zamanla sıkışabilir. Yüksek yoğunluklu model daha uzun ömürlüdür. Yoğun
          trafikli alanlarda yüksek yoğunluk tercih edilir. Stüdyo ve kayıt odasında standart yoğunluk
          çoğu durumda yeterlidir.
        </p>

        <h3 className={styles.seoSubtitle}>Uygulama yapılacak yüzey özellikleri</h3>
        <p className={styles.seoText}>
          Yüzey temiz, kuru ve düzgün olmalıdır. Nemli yüzeylerde önce kurutma yapılmalıdır. Alçıpan, beton
          ve ahşap yüzeylere uygulanır. Tavan uygulamasında geçici destek gerekebilir. Dış cepheye bakan
          duvarlarda güneş ışığı solmaya neden olabilir.
        </p>
        <p className={styles.seoText}>
          Fiyat karşılaştırması yapılırken yalnızca birim fiyata bakmak yanıltıcı olabilir. Yanlış
          kalınlık seçimi yeniden sipariş gerektirir. Doğru ürün seçimi baştan yapıldığında düz akustik
          sünger uzun vadede ekonomik bir yatırımdır. WhatsApp hattımızdan anında teklif alabilirsiniz.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Düz Sünger Nasıl Uygulanır?</h2>

        <h3 className={styles.seoSubtitle}>Yüzey hazırlığı</h3>
        <p className={styles.seoText}>
          Yüzey temiz, kuru ve tozdan arındırılmış olmalıdır. Gevşek boya yapışmayı zayıflatır. Montaj
          planı çizilerek panel yerleşimi önceden belirlenir. İlk yansıma noktaları işaretlenir.
        </p>
        <p className={styles.seoText}>
          Oda içindeki mobilya montaj öncesi çekilmelidir. Elektrik prizleri ve anahtarlar panel kesiminde
          dikkate alınır. Maket bıçağı ile priz çevresi temiz kesilir. Montaj sırasında oda
          havalandırılmalıdır.
        </p>

        <h3 className={styles.seoSubtitle}>Yapıştırıcı seçimi</h3>
        <p className={styles.seoText}>
          Düz akustik sünger için solvent içermeyen özel yapıştırıcı kullanılır. Solvent bazlı
          yapıştırıcılar süngeri eritebilir. Sprey yapıştırıcı büyük alanlarda pratiktir. Kendinden
          yapışkanlı modellerde arka yüz koruma bandı kaldırılarak yapıştırılır.
        </p>
        <p className={styles.seoText}>
          Endüstriyel projelerde mekanik sabitleme de kullanılabilir. Tavan uygulamasında yapıştırıcı ile
          birlikte geçici bant desteği önerilir. Nemli ortamlarda nem dirençli yapıştırıcı tercih edilir.
        </p>

        <h3 className={styles.seoSubtitle}>Panellerin düzgün yerleştirilmesi</h3>
        <p className={styles.seoText}>
          Tüm yüzeyi kaplamak her zaman doğru değildir. Hoparlör veya konuşmacı hizasındaki ilk yansıma
          noktaları önceliklidir. Arka duvar hedeflenir. Dengeli kaplama ilkesi her projede geçerlidir.
          Stüdyolarda mirror point hesabı yapılır.
        </p>
        <p className={styles.seoText}>
          Yapıştırıcı hem süngere hem duvara sürülür. 30 saniye bekledikten sonra panel bastırılır. Düz
          yüzey birleşimleri daha düzgün görünür. Köşe birleşimlerinde bass trap düşük frekans
          performansını artırır.
        </p>
        <p className={styles.seoText}>
          Düz panel birleşim noktalarında görünür çizgi oluşabilir. Profesyonel montajda paneller hizalı
          yerleştirilir. Köşe birleşimlerinde L profil veya bass trap kullanılır. Geniş duvarlarda panel
          ortasına ek destek gerekmez. Yapıştırıcı yeterli tutunma sağlar.
        </p>

        <h3 className={styles.seoSubtitle}>Uygulama sonrası dikkat edilmesi gerekenler</h3>
        <p className={styles.seoText}>
          Paneller arasında 2-5 mm boşluk bırakmak genleşmeye izin verir. Tavan uygulamasında geçici bant
          kullanılır. Montaj sonrası oda akustiği kulağa hemen fark edilir. Echopan montaj kılavuzu
          siparişle birlikte gönderilir. WhatsApp hattımızdan montaj desteği alınabilir.
        </p>
        <p className={styles.seoText}>
          Yapıştırıcı tam kuruduktan sonra mobilya yerine konulabilir. İlk 24 saat yoğun havalandırma
          önerilir. Panel kenarlarında boşluk bırakmak genleşmeye izin verir.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Düz Sünger Fiyatlarını Etkileyen Faktörler</h2>
        <p className={styles.seoText}>
          Akustik düz sünger fiyatı metrekare başına 320 TL dir. Aşağıdaki unsurlar toplam maliyeti
          etkiler. Teklif almak için kalınlık, metraj ve teslimat adresi paylaşılmalıdır.
        </p>

        <h3 className={styles.seoSubtitle}>Kalınlık</h3>
        <p className={styles.seoText}>
          Kalınlık arttıkça birim maliyet yükselir. 20 mm en ekonomik giriş seviyesidir. 50 mm en yüksek
          birim fiyatlı standart kalınlıktır. Doğru kalınlık seçimi gereksiz harcamayı önler.
        </p>
        <p className={styles.seoText}>
          20 mm panel metrekare başına en düşük malzeme maliyetini sunar. 30 mm fiyat ve performans dengesi
          açısından en çok tercih edilen kalınlıktır. Endüstriyel projelerde 40-50 mm yaygındır.
        </p>

        <h3 className={styles.seoSubtitle}>Yoğunluk</h3>
        <p className={styles.seoText}>
          Yüksek yoğunluklu sünger birim fiyatı artırır. Profesyonel stüdyo projelerinde yüksek yoğunluk
          tercih edilir. Konut uygulamalarında standart yoğunluk yeterli olabilir.
        </p>
        <p className={styles.seoText}>
          Yoğunluk farkı birim fiyatta yüzde 10-15 aralığında değişiklik yaratabilir. Büyük projelerde bu
          fark toplam maliyeti etkiler. Teklif alırken yoğunluk tercihinizi belirtin. Teknik ekibimiz
          projenize uygun yoğunluğu önerir.
        </p>

        <h3 className={styles.seoSubtitle}>Sipariş miktarı</h3>
        <p className={styles.seoText}>
          Büyük metrajlı siparişlerde birim fiyat avantajı sağlanabilir. Tek plaka siparişi de kabul
          edilir. Kurumsal projelerde parti parti teslimat planlanabilir.
        </p>
        <p className={styles.seoText}>
          50 m² ve üzeri siparişlerde birim fiyat avantajı sağlanabilir. Endüstriyel projelerde metraj
          genelde 100 m² üzerindedir. Metraj paylaşıldığında toplam maliyet aynı gün hesaplanır.
        </p>

        <h3 className={styles.seoSubtitle}>Özel ölçü ve üretim talepleri</h3>
        <p className={styles.seoText}>
          Özel kesim ve kendinden yapışkanlı yüzey birim maliyeti etkiler. CNC kesimli özel parçalar
          standart plakadan farklı fiyatlanır.{' '}
          <Link to="/akustik-sunger" rel="follow">
            Akustik sünger
          </Link>{' '}
          ana sayfamızdan diğer profil ve fiyat bilgilerine ulaşabilirsiniz.
        </p>
        <p className={styles.seoText}>
          Kendinden yapışkanlı yüzey birim maliyeti yüzde 15-20 artırır. Ancak montaj süresini yarıya
          indirir. İşçilik maliyeti yüksek projelerde kendinden yapışkanlı model ekonomik olabilir. Ev
          kullanıcıları için en pratik seçenektir.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Akustik Düz Sünger Hakkında Sık Sorulan Sorular</h2>

        <h3 className={styles.seoSubtitle}>Akustik düz sünger sesi tamamen keser mi?</h3>
        <p className={styles.seoText}>
          Hayır. Akustik düz sünger oda içindeki yankıyı azaltır, sesi kesmez. Komşu duvarından gelen
          sesi engellemek için bondex veya bariyerli bondex kullanılmalıdır.
        </p>
        <p className={styles.seoText}>
          Düz sünger oda içi akustik düzenleme ürünüdür. Duvar arkasına serildiğinde komşu sesi kesmez.
          Ses geçişi ile yankı kontrolü farklı ihtiyaçlara karşılık verir. Aynı projede ikisi birlikte
          kullanılabilir.
        </p>

        <h3 className={styles.seoSubtitle}>Ev ve ofislerde kullanılabilir mi?</h3>
        <p className={styles.seoText}>
          Ev sinema odası, müzik odası, çalışma odası ve ofis toplantı odalarında güvenle kullanılır.
          Yangına dayanıklı E sınıfı modellerimiz konut ve ticari uygulamalara uygundur.
        </p>
        <p className={styles.seoText}>
          Ev müzik odasında bir duvar kaplaması bile fark yaratır. Kendinden yapışkanlı modeller kiracılar
          için idealdir. Ofis toplantı odasında konuşma netliği belirgin şekilde artar.
        </p>

        <h3 className={styles.seoSubtitle}>Tavana uygulanabilir mi?</h3>
        <p className={styles.seoText}>
          Tavanda kullanılabilir. Hafif paneller yapıştırıcı ile sabitlenir. Büyük plakalarda geçici destek
          önerilir. Tavan yansımalarını kontrol altına almak için yaygın tercih edilir.
        </p>
        <p className={styles.seoText}>
          Tavan paneli hoparlör veya mikrofon hizasına yerleştirilir. Büyük plakalarda montaj sırasında
          geçici bant ile desteklenir. Yapıştırıcı kuruduktan sonra bant kaldırılır.
        </p>

        <h3 className={styles.seoSubtitle}>Yangına dayanıklı seçenekleri var mı?</h3>
        <p className={styles.seoText}>
          Evet. Tüm düz akustik sünger modellerimiz TS EN 13501-1 standardına göre E sınıfı yanmazlık
          sertifikasına sahiptir. Okul ve ticari proje taleplerinde sertifika paylaşılır.
        </p>
        <p className={styles.seoText}>
          Yangın sertifikası belediye ve iş güvenliği denetimlerinde talep edilir. E sınıfı ürünlerimiz
          bu denetimlerde sorun çıkarmaz. Sertifika PDF olarak e-posta ile gönderilir. Fiziksel kopya
          talep edildiğinde kargo ile iletilir.
        </p>

        <h3 className={styles.seoSubtitle}>Nasıl temizlenir?</h3>
        <p className={styles.seoText}>
          Yumuşak fırça veya elektrik süpürgesi ile toz alınır. Nemli bezle silmek mümkündür ancak aşırı
          su kullanmayın.           Kimyasal temizleyici sünger yapısına zarar verebilir.
        </p>
        <p className={styles.seoText}>
          Düz yüzey toz tuttuğunda emilim performansı hafif düşer. Altı ayda bir toz alma önerilir.
          Endüstriyel alanlarda üç ayda bir temizlik yapılmalıdır. Leke oluşursa nemli bezle silinir.
          Kurumaya bırakılmalıdır.
        </p>

        <h3 className={styles.seoSubtitle}>Kullanım ömrü ne kadardır?</h3>
        <p className={styles.seoText}>
          Doğru montaj ve normal kullanım koşullarında 10 yıl ve üzeri performans korunur. Doğrudan güneş
          ışığına maruz kalan yüzeylerde erken solma görülebilir. Fiziksel darbe emilimi düşürebilir.
        </p>
        <p className={styles.seoText}>
          Düz sünger ile ne kadar alan kaplanmalı sorusunun cevabı mekan boyutuna bağlıdır. Stüdyo ve kayıt
          odalarında duvar ve tavan alanının yaklaşık yüzde 30-50 si kaplanır. Endüstriyel alanlarda
          yüzde 50-70 kaplama yapılabilir. Teknik ekibimizden metraj önerisi alabilirsiniz.
        </p>
      </section>
    </div>
  );
}
